<template>
    <verify-data-form />
</template>
<script>
    import VerifyDataForm from './form/VerifyDataForm';

    export default {
        name: 'verify-data-page',
        components: {
            VerifyDataForm
        }
    }
</script>
